import { z } from 'zod/v4'

import { extractOptionValue } from './propertyRules'

export type ProductLinkValidation = {
  translationKey: 'Product.link-invalid-url'
  fallbackMessage: string
}

const INVALID_LINK_ERROR: ProductLinkValidation = {
  translationKey: 'Product.link-invalid-url',
  fallbackMessage: "L'URL doit inclure le protocole (http:// ou https://)",
}

export const normalizeProductLinkValue = (value: unknown): string => {
  const extracted = extractOptionValue(value)
  return typeof extracted === 'string' ? extracted.trim() : ''
}

export const validateProductLinkValue = (
  value: string,
): ProductLinkValidation | null => {
  const trimmed = value.trim()
  if (!trimmed) return null
  if (!/^https?:\/\//i.test(trimmed)) return INVALID_LINK_ERROR
  return z.url().safeParse(trimmed).success ? null : INVALID_LINK_ERROR
}
